"use client";
import {
  useRangeCalendar
} from "./chunk-RR4PNVXG.mjs";
import {
  CalendarBase
} from "./chunk-7FIJ2QLY.mjs";
import {
  CalendarProvider
} from "./chunk-HCKEJHY3.mjs";

// src/range-calendar.tsx
import { forwardRef } from "@nextui-org/system";
import { jsx } from "react/jsx-runtime";
var RangeCalendar = forwardRef(function RangeCalendar2(props, ref) {
  const { context, getBaseCalendarProps } = useRangeCalendar({ ...props, ref });
  return /* @__PURE__ */ jsx(CalendarProvider, { value: context, children: /* @__PURE__ */ jsx(CalendarBase, { ...getBaseCalendarProps() }) });
});
var range_calendar_default = RangeCalendar;

export {
  range_calendar_default
};
